var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"thumb",staticClass:"w-scroll-view-thumb",class:{active:_vm.isDragging, vertical:!_vm.isHorizontal, horizontal:_vm.isHorizontal, hidden: _vm.hidden},on:{"mousedown":function($event){return _vm.onMouseDown($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }